import _ from 'underscore';
import Backbone from 'backbone';
import Widget_Templates from 'root/module/widget_templates';

var Widget = Backbone.Model.extend({
    defaults: {
        widget_version                     : 1,
        account_id                         : 0,
        project_id                         : 0,
        total_load                         : 0,
        total_impression                   : 0,
        is_active                          : true,
        use_case                           : '',
        style                              : 'text',
        icon                               : 1,
        icon_url                           : '',
        position                           : 'se',
        language                           : 'en',
        workflow_type                      : 'bug,feature_request,general', // capture, video, bug, feature_request, general
        feedback_type                      : 'bug,feature_request,general',
        feedback_type_default              : '',
        logo                               : '',
        launcher_offset_x                  : 0,
        launcher_offset_y                  : 0,
        header_text                        : '',
        routing_item_order                 : 'bug,feature_request,general,view_other,help',
        text_screenshot                    : '',
        text_screenshot_help               : '',
        text_video                         : '',
        text_video_help                    : '',
        text_general                       : '',
        text_general_help                  : '',
        text_report_bug                    : '',
        text_report_bug_help               : '',
        text_feature_request               : '',
        text_feature_request_help          : '',
        text_view_other                    : '',
        text_view_other_help               : '',
        text_feedback_type_bug             : '',
        text_feedback_type_general         : '',
        text_feedback_type_feature_request : '',
        text_feedback                      : '',
        text_portal                        : '',
        text_roadmap                       : '',
        text_announcement                  : '',
        direct_to_bug                      : 'form',
        direct_to_feature_request          : 'form',
        direct_to_general                  : 'form',
        portal_target                      : 'window',
        roadmap_target                     : 'window',
        announcement_target                : 'window',
        help_target                        : 'window',
        help_link                          : '',
        help_title                         : '',
        help_message                       : '',
        display_feedback                   : false,
        display_powered_by                 : true,
        trigger_type                       : 'page_load',
        page_condition                     : '',
        page_load_delay                    : 0,
        device_type                        : 'desktop,tablet,phone',
        url_match_type                     : '',
        url_match_val                      : '',
        user_segment                       : 0,
        display_tutorial                   : 0,
        autohide                           : false,
        use_modal                          : false,
        all_domain                         : false,
        auto_screenshot                    : false,
        main_button_text                   : 'Feedback',
        main_button_text_colour            : '#FFFFFF',
        main_button_background_colour      : '#6042EC',
        video_time                         : 180,
        use_hcaptcha                       : false,
        capture_event                      : false,
        capture_console_log                : false,
        capture_console_error              : false,
        capture_console_warn               : false,
        capture_console_info               : false,
        capture_console_debug              : false,
        capture_session_recording          : false,
        capture_network                    : false,
        ai_feedback_type                   : false
    },

    getUseCaseName: function() {
        var template_name = '';

        _.each(Widget_Templates, function(template) {
            if (template.val && template.val === this.get('use_case')) {
                template_name = template.text;
            }
        }, this);

        return template_name;
    },

    getUseCaseDesc: function() {
        var template_desc = '';

        _.each(Widget_Templates, function(template) {
            if (template.val && template.val === this.get('use_case')) {
                template_desc = template.desc;
            }
        }, this);

        return template_desc;
    },

    hasBottomNav: function() {
        return this.isNextGen() && (this.get('workflow_type').indexOf('portal') !== -1 || this.get('workflow_type').indexOf('roadmap') !== -1 || this.get('workflow_type').indexOf('announcement') !== -1 || this.get('help_link'));
    },

    isNextGen: function() {
        return this.get('widget_version') === 2;
    },

    isActive: function() {
        return this.get('is_active')
    }
});

export default Widget;